import React, { useState, useEffect, useCallback } from "react";
import {
  Input,
  Form,
  Typography,
  Button,
  Flex,
  InputNumber,
  Select,
  Row,
  Col,
  Switch
} from "antd";
import {
  PlusCircleOutlined,
  MinusCircleOutlined
} from "@ant-design/icons";
import { useParams } from "react-router-dom";
import axios from "../../axios-interceptor.js";
import { useTranslation } from "react-i18next";
import { showLoader } from "../../utils/showloader.js";

const { Option } = Select;

const BACKEND_API = process.env.REACT_APP_BACKEND_API;
const lastOptions = [
  {
    value: "updatedOn",
    label: "Last updated date",
  }
];

const periods = [
  { label: "Days", value: "day" },
  { label: "Weeks", value: "week" },
  { label: "Months", value: "month" },
  { label: "Quarters", value: "quarter" },
  { label: "Years", value: "year" }
]

const Rules = (props) => {
  const { rulesData, setRulesData } = props;
  const { t } = useTranslation();
  const values = {}


  const handleChange = (mainKey, key, val) => {
    if (val < 0) return
    setRulesData({ ...rulesData, [mainKey]: { ...rulesData[mainKey], [key]: val } })
  }



  // const preventFormatAlpha = (mainKey, key, val) => {
  //   let ans = val ? val.replace(/[^\d]/g, '') : 0
  //   handleStateUpdate(mainKey, key, val)
  //   debugger

  // }

  return (
    <div className="space-rules" style={{ background: "#fff", borderRadius: "1rem" }}>
      <div className="space-setting">
        <div className="space-heading">{t("Rules")}</div>
      <Flex vertical style={{ gap: "1rem" }}>
        <div>
          <Switch className="custom-switch" size="small" value={rulesData.archive.enable} onChange={(checked) => handleChange("archive", 'enable', checked)} /> <span className="text-color-primary" style={{ marginLeft: "0.5rem" }}>{t("Archive approval request")}</span>
        </div>
        {
          rulesData.archive.enable ?
            <Row gutter={8}>
              <Col span={2}>
                <div style={{ width: '100%', border: '1px solid rgba(217, 217, 217, 1)', display: 'flex', justifyContent: 'space-around', borderRadius: '10px' }} >
                  <Button
                    style={{ border: 'none', padding: '0px', height: "20px", marginTop: "3px" }}
                    onClick={() => {
                      const currentDay = rulesData?.archive?.count || 0;
                      handleChange('archive', 'count', Number(currentDay) - 1)
                    }}>
                    <MinusCircleOutlined style={{ marginLeft: "3px", padding: '0px', cursor: rulesData?.archive?.count == 0 ? "not-allowed" : "pointer", color: rulesData?.archive?.count == 0 ? 'grey' : "rgba(20, 27, 203, 1)" }} />
                  </Button>

                  <InputNumber
                    style={{ width: '70%', border: 'none' }}
                    min={0}
                    controls={true}
                    value={rulesData?.archive?.count}
                    onChange={(value) => handleChange('archive', 'count', value)}
                  // parser={(value) => preventAlpha('archive', 'count', value)}
                  // formatter={(value) => preventFormatAlpha('archive', 'count', value)} // Ensure it displays correctly
                  />

                  <Button
                    style={{ border: 'none', padding: '0px', height: "20px", marginTop: "3px" }}
                    onClick={() => {
                      const currentDay = rulesData?.archive?.count || 0;
                      handleChange('archive', 'count', Number(currentDay) + 1)
                    }}
                  >
                    <PlusCircleOutlined style={{ marginRight: "4px", padding: '0px', color: "rgba(20, 27, 203, 1)" }} />
                  </Button>
                </div>
              </Col>
              <Col span={2}>
                <Select style={{ width: "100%" }} value={rulesData?.archive?.period} options={periods.map(period => ({ label: t(period.label), value: period.value }))} onChange={(val) => handleChange('archive', 'period', val)} />
              </Col>
              <Col span={2}>
                <Select className="rule-period" disabled style={{ width: "100%" }} value={rulesData.archive.occurrence} onChange={(val) => handleChange("archive", 'occurrence', val)}
                  options={[
                    {
                      value: "after",
                      label: t("After"),
                    },
                  ]}
                />
              </Col>
              <Col span={4}>
                <Select className="rule-period" style={{ width: "100%", marginBottom: "24px" }} value={rulesData.archive.event} handleChange={(val) => handleChange('archive', 'event', val)} placeholder={t("Please select a value")}>
                  {
                    lastOptions.map(option => {
                      return <Select.Option value={option.value}>{t(option.label)}</Select.Option>
                    })
                  }
                </Select>
              </Col>
            </Row>
            : null
        }

      </Flex>

      <Flex vertical style={{ gap: "1rem", marginTop: "0.75rem" }}>
        <div>
          <Switch className="custom-switch" size="small" value={rulesData?.delete?.enable} onChange={(checked) => handleChange("delete", 'enable', checked)} /> <span className="text-color-primary" style={{ marginLeft: "0.5rem" }}>{t("Delete approval request")}</span>
        </div>

        {
          rulesData.delete.enable ?
            <Row gutter={8}>
              <Col span={2}>
                <div style={{ width: '100%', border: '1px solid rgba(217, 217, 217, 1)', display: 'flex', justifyContent: 'space-around', borderRadius: '10px' }} >
                  <Button
                    style={{ border: 'none', padding: '0px', height: "20px", marginTop: "3px" }}
                    onClick={() => {
                      const currentDay = rulesData?.delete?.count || 0;
                      handleChange('delete', 'count', Number(currentDay) - 1)
                    }}>
                    <MinusCircleOutlined style={{ marginLeft: "3px", padding: '0px', cursor: rulesData?.delete?.count == 0 ? "not-allowed" : "pointer", color: values?.day == 0 ? 'grey' : 'rgba(20, 27, 203, 1)' }} />
                  </Button>

                  <InputNumber
                    placeholder={t('Number')}
                    style={{ width: '70%', border: 'none' }}
                    min="0"
                    controls={true}
                    value={rulesData?.delete?.count}
                    onChange={(value) => handleChange('archive', 'count', value)}
                    parser={(value) => value.replace(/\D/g, '')} // Removes non-numeric characters
                    formatter={(value) => value.replace(/\D/g, '')}
                  />
                  <Button
                    style={{ border: 'none', padding: '0px', height: "20px", marginTop: "3px" }}
                    onClick={() => {
                      const currentDay = rulesData?.delete?.count || 0;
                      handleChange('delete', 'count', Number(currentDay) + 1)
                    }}>
                    <PlusCircleOutlined style={{ marginRight: "4px", padding: '0px', color: "rgba(20, 27, 203, 1)" }} />
                  </Button>
                </div>
              </Col>
              <Col span={2}>
                <Select style={{ width: "100%" }} value={rulesData.delete.period} options={periods.map(period => ({ label: t(period.label), value: period.value }))} onChange={(val) => handleChange('delete', 'period', val)} />
              </Col>
              <Col span={2}>
                <Select className="rule-period" disabled style={{ width: "100%" }} value={rulesData?.delete?.occurrence} onChange={(val) => handleChange("delete", 'occurrence', val)}
                  options={[
                    {
                      value: "after",
                      label: t("After"),
                    },
                  ]}
                />
              </Col>
              <Col span={4}>
                <Select className="rule-period" style={{ width: "100%", marginBottom: "24px" }} value={rulesData?.delete?.event} handleChange={(val) => handleChange('delete', 'event', val)} placeholder={t("Please select a value")}>
                  {
                    lastOptions.map(option => {
                      return <Select.Option value={option.value}>{t(option.label)}</Select.Option>
                    })
                  }
                </Select>
              </Col>
            </Row>
            : null
        }

      </Flex>
      </div>
    </div>
  );
};

export default Rules;
